/**
 * Small version predicates shared across layers (lib is importable by anyone).
 *
 * OCPP 2.1 is a backward-compatible superset of 2.0.1: it speaks the same
 * OCPP 2.x message framework + Device Model and runs on the OcppV201Adapter
 * (with the 2.1 schema registry). So everywhere the app branched on
 * `version === '2.0.1'` to mean "the OCPP 2.x family" it should also match 2.1.
 */
export type OcppVersionString = '1.6J' | '2.0.1' | '2.1';

/** True for the OCPP 2.x family (2.0.1 + 2.1) — Device Model, TransactionEvent, etc. */
export function isV2x(version: string): boolean {
  return version === '2.0.1' || version === '2.1';
}

/** WebSocket subprotocol token to advertise for an OCPP version. */
export function subprotocolFor(version: string): string {
  if (version === '2.1') return 'ocpp2.1';
  if (version === '2.0.1') return 'ocpp2.0.1';
  return 'ocpp1.6';
}
